import { Action, createReducer, on } from '@ngrx/store';
import { getCompliancePermissionsFailure, getCompliancePermissionsSuccess } from '../actions/compliance.actions';
import { CompliancePermissionsState } from '../state/compliance-permissions.state';

const initialState: CompliancePermissionsState = {
    compliancePermissions: undefined,
    error: null
};

const reducer = createReducer(
    initialState,

    on(getCompliancePermissionsSuccess, (state, action) => ({
        ...state,
        compliancePermissions: action.compliancePermissions,
        error: ''
    })),

    on(getCompliancePermissionsFailure, (state, action) => ({
        ...state,
        compliancePermissions: null,
        error: JSON.stringify(action.error)
    }))
);

export function compliancePermissionsReducer(state: CompliancePermissionsState | undefined, action: Action) {
    return reducer(state, action);
}
